'use strict';
var formValidation = require('base/components/formValidation');
/**
 * Submits the conatct form to the ContactUs-Subscribe route
 * @param {JQuery} form - the group order form as a jQuery object
 * @param {string} url - the Catalog-Submit route's url
 */
function grouporder(form, url) {
    var groupOrderFormData = form.serialize();
    $.ajax({
        url: url,
        type: 'post',
        data: groupOrderFormData,
        success: function (data) {
            if (data && !data.result && !data.success) {
                formValidation(form, data);
                $('form.groupOrder').trigger('groupOrder:error', data);
            } else {
                form.remove();
                $('#btnGroupOrderScroll, #groupOrderTitle').remove();
                $('#group-order-form').append('<div id="groupOrderSuccess" class="text-center">' + data.result + '</div>');
                $('html, body').animate({
                    scrollTop: $('#groupOrdersPage').offset().top - 100
                }, 500);
            }
        },
        always: function () {
            form.spinner().stop();
        }
    });
}

module.exports = {
    sendGroupOrder: function () {
        const form = $('form.groupOrderFormAsset').on('submit', (e) => {
            e.preventDefault();
            form.spinner().start();
            var url = form.attr('action');
            var $recaptcha = form.find('[name="g-recaptcha-response"]');
            if ($recaptcha.length) {
                var siteKey = $recaptcha.data('sitekey');
                var action = form.find('[name="g-recaptcha-action"]').val();
                var recaptchExecCB = function (token) { // eslint-disable-line 
                    $recaptcha.val(token);
                    grouporder(form, url);
                };
                if (grecaptcha.enterprise) { // eslint-disable-line
                    grecaptcha.enterprise.ready(function () { // eslint-disable-line
                        grecaptcha.enterprise.execute(siteKey, { action: action }).then(recaptchExecCB); // eslint-disable-line
                    });
                } else {
                    grecaptcha.ready(function () { // eslint-disable-line
                        grecaptcha.execute(siteKey, { action: action }).then(recaptchExecCB); // eslint-disable-line
                    });
                }
            } else {
                grouporder(form, url);
            }
            form.spinner().stop();
        });
    },

    scrollToForm: function () {
        $('a[href*="#groupOrdersPage"], #btnGroupOrderScroll').on('click', function (e) {
            e.preventDefault();
            var headerSpacing = 0;
            var offsetHeader = $('.header-banner').length ? $('.header-banner').outerHeight() : 0;
            var offsetTopMenu = $('.top-menu').length ? $('.top-menu').outerHeight() : 0;

            if ($('.site-header').hasClass('is-stuck')) {
                headerSpacing = 100;
            } else {
                headerSpacing = offsetHeader + offsetTopMenu + 20;
            }

            $('html, body').animate({
                scrollTop: $('form.groupOrder').offset().top - headerSpacing
            }, 500);
            $('#btnGroupOrderScroll').addClass('d-none');
        });
    },

    windowScroll: function () {
        $(window).on('scroll', function () {
            var windowHeight = $(window).outerHeight();
            var windowScroll = $(window).scrollTop();
            var formOffsetTop = $('#groupOrdersPage').offset().top;
            if ((windowScroll + windowHeight) > formOffsetTop) {
                $('#btnGroupOrderScroll').addClass('d-none');
            } else {
                $('#btnGroupOrderScroll').removeClass('d-none');
            }
        });
    },

    toggleSeoContent: function () {
        if ($('#contentGroupOrderSeo').length === 0) {
            $('#btnGroupOrderSeo').addClass('d-none');
        }

        $('#btnGroupOrderSeo').on('click', function () {
            $('#contentGroupOrderSeo').removeClass('d-none');
            $(this).addClass('d-none');
        });
    }
};
